// extracted by mini-css-extract-plugin
export var highlightFade = "_2h-4";
export var highlighted = "_2h-3";
export var table = "_2h-1";
export var tableContainer = "_2h-0";
export var totalsRow = "_2h-2";